import React from "react";
import { StatusType, getStatusIconColor } from "../../../constants/status";
import { getStatusIconComponent, getExcludedIconComponent } from "../../../constants/status/statusIcons";
import { resolveThemeMode } from "../../../utils/statusUtils";
import { useTheme } from "@material-ui/core";

export interface StatusIconProps {
  status: StatusType;
  excluded?: boolean;
  fontSize?: "inherit" | "default" | "small" | "large";
  className?: string;
  /** When true, applies the status main color to the icon. */
  colored?: boolean;
}

function StatusIcon({ status, excluded, fontSize = "small", className, colored = true }: StatusIconProps) {
  const theme = useTheme();
  const mode = resolveThemeMode(theme.palette.type);
  const Icon = excluded ? getExcludedIconComponent() : getStatusIconComponent(status);
  const color = colored ? getStatusIconColor(status, mode) : undefined;

  return (
    <span style={color ? { color, display: "inline-flex" } : { display: "inline-flex" }} aria-hidden="true">
      <Icon fontSize={fontSize} className={className} />
    </span>
  );
}

export default StatusIcon;
